
export interface Font {
  width: number;
  height: number;
  data: Record<number, number[]>; // ASCII code -> array of rows (binary bits)
}

// Minimal 3x5 font
const font3x5: Font = {
  width: 3,
  height: 5,
  data: {
    32: [0, 0, 0, 0, 0], // Space
    65: [2, 5, 7, 5, 5], // A
    66: [6, 5, 6, 5, 6], // B
    67: [3, 4, 4, 4, 3], // C
    68: [6, 5, 5, 5, 6], // D
    69: [7, 4, 6, 4, 7], // E
    70: [7, 4, 6, 4, 4], // F
    71: [3, 4, 5, 5, 3], // G
    72: [5, 5, 7, 5, 5], // H
    73: [7, 2, 2, 2, 7], // I
    74: [1, 1, 1, 5, 2], // J
    75: [5, 5, 6, 5, 5], // K
    76: [4, 4, 4, 4, 7], // L
    77: [5, 7, 5, 5, 5], // M
    78: [5, 5, 5, 7, 5], // N
    79: [2, 5, 5, 5, 2], // O
    80: [6, 5, 6, 4, 4], // P
    81: [2, 5, 5, 6, 1], // Q
    82: [6, 5, 6, 5, 5], // R
    83: [3, 4, 2, 1, 6], // S
    84: [7, 2, 2, 2, 2], // T
    85: [5, 5, 5, 5, 7], // U
    86: [5, 5, 5, 5, 2], // V
    87: [5, 5, 5, 7, 5], // W
    88: [5, 5, 2, 5, 5], // X
    89: [5, 5, 2, 2, 2], // Y
    90: [7, 1, 2, 4, 7], // Z
    48: [2, 5, 5, 5, 2], // 0
    49: [2, 6, 2, 2, 7], // 1
    50: [6, 1, 2, 4, 7], // 2
    51: [6, 1, 2, 1, 6], // 3
    52: [5, 5, 7, 1, 1], // 4
    53: [7, 4, 6, 1, 6], // 5
    54: [2, 4, 6, 5, 2], // 6
    55: [7, 1, 2, 2, 2], // 7
    56: [2, 5, 2, 5, 2], // 8
    57: [2, 5, 3, 1, 2], // 9
    46: [0, 0, 0, 0, 2], // .
    44: [0, 0, 0, 2, 4], // ,
    33: [2, 2, 2, 0, 2], // !
    63: [6, 1, 2, 0, 2], // ?
  }
};

// Dedicated 4x6 Font
const font4x6: Font = {
  width: 4,
  height: 6,
  data: {
    32: [0, 0, 0, 0, 0, 0], // Space
    65: [6, 9, 15, 9, 9, 9], // A
    66: [14, 9, 14, 9, 9, 14], // B
    67: [6, 9, 8, 8, 9, 6], // C
    68: [12, 10, 9, 9, 10, 12], // D
    69: [15, 8, 14, 8, 8, 15], // E
    70: [15, 8, 14, 8, 8, 8], // F
    71: [6, 9, 8, 11, 9, 6], // G
    72: [9, 9, 15, 9, 9, 9], // H
    73: [14, 4, 4, 4, 4, 14], // I
    74: [2, 2, 2, 2, 10, 4], // J
    75: [9, 10, 12, 10, 9, 9], // K
    76: [8, 8, 8, 8, 8, 15], // L
    77: [9, 15, 15, 9, 9, 9], // M
    78: [9, 13, 11, 9, 9, 9], // N
    79: [6, 9, 9, 9, 9, 6], // O
    80: [14, 9, 14, 8, 8, 8], // P
    81: [6, 9, 9, 9, 10, 5], // Q
    82: [14, 9, 14, 10, 9, 9], // R
    83: [6, 9, 4, 2, 9, 6], // S
    84: [15, 4, 4, 4, 4, 4], // T
    85: [9, 9, 9, 9, 9, 6], // U
    86: [9, 9, 9, 9, 10, 4], // V
    87: [9, 9, 9, 15, 15, 9], // W
    88: [9, 9, 6, 6, 9, 9], // X
    89: [9, 9, 6, 4, 4, 4], // Y
    90: [15, 2, 4, 8, 8, 15], // Z
    48: [6, 9, 11, 13, 9, 6], // 0
    49: [4, 12, 4, 4, 4, 14], // 1
    50: [6, 9, 2, 4, 8, 15], // 2
    51: [14, 1, 6, 1, 9, 6], // 3
    52: [2, 6, 10, 15, 2, 2], // 4
    53: [15, 8, 14, 1, 1, 14], // 5
    54: [6, 8, 14, 9, 9, 6], // 6
    55: [15, 1, 2, 4, 4, 4], // 7
    56: [6, 9, 6, 9, 9, 6], // 8
    57: [6, 9, 9, 7, 1, 6], // 9
    46: [0, 0, 0, 0, 0, 4], // .
    44: [0, 0, 0, 0, 4, 8], // ,
    33: [4, 4, 4, 4, 0, 4], // !
    63: [6, 9, 2, 4, 0, 4], // ?
  }
};

// Standard 5x7 font data
const font5x7: Font = {
  width: 5,
  height: 7,
  data: {
    32: [0,0,0,0,0,0,0],
    65: [4,10,17,17,31,17,17],
    66: [30,17,17,30,17,17,30],
    67: [14,17,16,16,16,17,14],
    68: [28,18,17,17,17,18,28],
    69: [31,16,16,30,16,16,31],
    70: [31,16,16,30,16,16,16],
    71: [14,17,16,23,17,17,14],
    72: [17,17,17,31,17,17,17],
    73: [14,4,4,4,4,4,14],
    74: [7,2,2,2,2,18,12],
    75: [17,18,20,24,20,18,17],
    76: [16,16,16,16,16,16,31],
    77: [17,27,21,21,17,17,17],
    78: [17,17,25,21,19,17,17],
    79: [14,17,17,17,17,17,14],
    80: [30,17,17,30,16,16,16],
    81: [14,17,17,17,21,18,13],
    82: [30,17,17,30,20,18,17],
    83: [15,16,16,14,1,1,30],
    84: [31,4,4,4,4,4,4],
    85: [17,17,17,17,17,17,14],
    86: [17,17,17,17,17,10,4],
    87: [17,17,17,21,21,27,17],
    88: [17,17,10,4,10,17,17],
    89: [17,17,10,4,4,4,4],
    90: [31,1,2,4,8,16,31],
    48: [14,17,19,21,25,17,14],
    49: [4,12,4,4,4,4,14],
    50: [14,17,1,2,4,8,31],
    51: [31,2,4,2,1,17,14],
    52: [2,6,10,18,31,2,2],
    53: [31,16,30,1,1,17,14],
    54: [6,8,16,30,17,17,14],
    55: [31,1,2,4,8,8,8],
    56: [14,17,17,14,17,17,14],
    57: [14,17,17,15,1,2,12],
    46: [0,0,0,0,0,0,4],
    44: [0,0,0,0,0,4,8],
    33: [4,4,4,4,4,0,4],
    63: [14,17,1,2,4,0,4],
  }
};

// Fallback for missing characters
const getPlaceholder = (w: number, h: number) => Array(h).fill((1 << w) - 1);

export const FONTS: Font[] = [
  font3x5,
  font4x6,
  font5x7
];

export function getCharBitmap(font: Font, char: string): number[] {
  const code = char.toUpperCase().charCodeAt(0);
  return font.data[code] || getPlaceholder(font.width, font.height);
}
